
/*
 * PAWS & PEARLS
 * LILLA'S WINGED ZEBRA AUDIO V1
 *
 * Adds sound only.
 * Synchronises to Lilla's existing
 * 30-second animation.
 */

(function () {
  'use strict';

  var script = document.currentScript ||
    document.querySelector(
      'script[data-pp-lilla-zebra-audio-v1]'
    );

  var audioUrl = script &&
    script.getAttribute('data-audio-src');

  if (
    !audioUrl ||
    !/^(https?:\/\/|\/)/.test(audioUrl)
  ) return;

  // MADAM'S ADJUSTABLE SETTINGS

  var PEAK_VOLUME = 0.40;

  var SILENT_VOLUME = 0.001;
  var FADE_IN_SECONDS = 1.0;
  var FADE_OUT_SECONDS = 1.7;

  var MIX_SECONDS = 30;
  var MAX_WAIT_MS = 60000;

  var sound = null;
  var interval = 0;
  var armedAt = 0;

  var began = false;
  var armed = false;
  var disposed = false;

  var smoothedVisibility = 0;

  function houseAllowsSound() {
    try {
      return !!(
        window.ppHouseSound &&
        typeof window.ppHouseSound.isEnabled ===
          'function' &&
        window.ppHouseSound.isEnabled() === true
      );
    } catch (_error) {
      return false;
    }
  }

  function zebraStatus() {
    var controller =
      window.ppMuseLillaZebraV1;

    if (
      !controller ||
      typeof controller.getStatus !== 'function'
    ) return null;

    try {
      return controller.getStatus();
    } catch (_error) {
      return null;
    }
  }

  function skyInView() {
    var sky = document.getElementById(
      'pp-muse-secret-sky'
    );

    if (!sky || !sky.isConnected) return false;

    var r = sky.getBoundingClientRect();

    var wrapper = document.querySelector(
      '.page-wrapper'
    );

    var v = wrapper
      ? wrapper.getBoundingClientRect()
      : {
          left: 0,
          right: innerWidth,
          top: 0,
          bottom: innerHeight
        };

    var left = Math.max(0, v.left);
    var right = Math.min(innerWidth, v.right);

    var top = Math.max(0, v.top);
    var bottom = Math.min(innerHeight, v.bottom);

    return (
      r.width > 0 &&
      r.height > 0 &&
      r.right > left &&
      r.left < right &&
      r.bottom > top &&
      r.top < bottom
    );
  }

  function stop() {
    armed = false;
    began = false;

    if (interval) {
      clearInterval(interval);
      interval = 0;
    }

    if (sound) {
      try {
        sound.volume = SILENT_VOLUME;
        sound.pause();
        sound.currentTime = 0;
        sound.loop = false;
      } catch (_error) {}
    }
  }

  function update() {
    if (!armed || disposed) return;

    if (
      !houseAllowsSound() ||
      document.hidden
    ) {
      stop();
      return;
    }

    var status = zebraStatus();

    if (!began) {

      // Lilla's controller first has a
      // 24-second waiting phase.
      //
      // Only begin audible playback
      // once her actual arrival begins.

      if (
        status &&
        status.present &&
        status.active &&
        status.phase !== 'waiting' &&
        status.phase !== 'not-running'
      ) {

        began = true;

        try {
          // Restart the soundtrack at
          // Lilla's actual entrance.
          sound.loop = false;
          sound.currentTime = 0;
          smoothedVisibility = 0;

        } catch (error) {
          console.warn(
            '[P&P Zebra Audio] Synchronisation failed:',
            error
          );

          stop();
        }

      } else if (
        performance.now() - armedAt >
        MAX_WAIT_MS
      ) {
        stop();
      }

      return;
    }

    // Never continue after Lilla's
    // animation has finished.

    if (
      !status ||
      !status.active ||
      !sound ||
      sound.ended
    ) {
      stop();
      return;
    }

    var seconds = sound.currentTime || 0;

    if (seconds >= MIX_SECONDS) {
      stop();
      return;
    }

    var fadeIn = Math.min(
      1,
      seconds / FADE_IN_SECONDS
    );

    var fadeOut = Math.min(
      1,
      (MIX_SECONDS - seconds) /
        FADE_OUT_SECONDS
    );

    var envelope = Math.max(
      0,
      Math.min(fadeIn, fadeOut)
    );

    // Soften if the visitor
    // scrolls away from the sky.

    smoothedVisibility += (
      (skyInView() ? 1 : 0) -
      smoothedVisibility
    ) * 0.18;

    var gain =
      envelope * smoothedVisibility;

    sound.volume = Math.max(
      0,
      Math.min(
        1,
        SILENT_VOLUME +
        (PEAK_VOLUME - SILENT_VOLUME) *
        gain
      )
    );
  }

  function onFlightClick(event) {
    if (
      disposed ||
      !houseAllowsSound()
    ) return;

    if (
      !document.documentElement.classList.contains(
        'pp-muse-secret-sky-page'
      )
    ) return;

    if (
      window.matchMedia &&
      window.matchMedia(
        '(prefers-reduced-motion: reduce)'
      ).matches
    ) return;

    var target = event.target;

    var clicked =
      target &&
      target.closest &&
      target.closest(
        '#pp-muse-balloon-stage .pp-balloon, ' +
        '.pp-muse-flight-overlay.pp-balloon'
      );

    if (
      !clicked ||
      !document.getElementById(
        'pp-muse-secret-sky'
      )
    ) return;

    var status = zebraStatus();

    if (!status || !status.present) return;

    stop();

    if (!sound) {
      sound = new Audio(audioUrl);
      sound.preload = 'auto';
    }

    try {
      sound.currentTime = 0;
      sound.volume = SILENT_VOLUME;

      // Safari: authorise playback during
      // the genuine visitor click.
      //
      // Remain effectively inaudible
      // during Lilla's waiting phase.
      //
      // Switch looping OFF at her arrival.

      sound.loop = true;

      armed = true;
      began = false;

      armedAt = performance.now();
      smoothedVisibility = 0;

      var result = sound.play();

      if (
        result &&
        typeof result.catch === 'function'
      ) {
        result.catch(function (error) {
          if (!armed) return;

          console.warn(
            '[P&P Zebra Audio] Playback unavailable:',
            error
          );

          stop();
        });
      }

      interval = setInterval(update, 65);

    } catch (error) {
      console.warn(
        '[P&P Zebra Audio] Could not start:',
        error
      );

      stop();
    }
  }

  function onSoundPreference() {
    if (!houseAllowsSound()) stop();
  }

  function onVisibilityChange() {
    if (document.hidden) stop();
  }

  function onSectionUnload(event) {
    var stage = document.getElementById(
      'pp-muse-balloon-stage'
    );

    if (
      !stage ||
      !event.target ||
      !event.target.contains(stage)
    ) return;

    disposed = true;
    stop();

    document.removeEventListener(
      'click',
      onFlightClick
    );

    document.removeEventListener(
      'pp:house-sound-change',
      onSoundPreference
    );

    window.removeEventListener(
      'pp:house-sound-change',
      onSoundPreference
    );

    document.removeEventListener(
      'visibilitychange',
      onVisibilityChange
    );

    document.removeEventListener(
      'shopify:section:unload',
      onSectionUnload
    );

    window.removeEventListener(
      'pagehide',
      stop
    );
  }

  document.addEventListener(
    'click',
    onFlightClick
  );

  document.addEventListener(
    'pp:house-sound-change',
    onSoundPreference
  );

  window.addEventListener(
    'pp:house-sound-change',
    onSoundPreference
  );

  document.addEventListener(
    'visibilitychange',
    onVisibilityChange
  );

  document.addEventListener(
    'shopify:section:unload',
    onSectionUnload
  );

  window.addEventListener(
    'pagehide',
    stop
  );

})();
